




import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";

@Component({
  extends: BaseView
})
export default class ForbiddenView extends Vue {}
